import { IPageAction, IPageLink } from "../../../base/models";
import { Link, useParams } from "react-router-dom";

import { FC } from "react";
import { MUIIcon } from "../../../widgets";
import { PageLinkHelper } from "../../../base/helpers";
import { Property } from "../../../base/types";
import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";

interface IActionButtonProps {
    action: IPageAction
    className?: string
}

export const ActionButton: FC<IActionButtonProps> = ({
    action, className
}) => {
    const { siteId } = useParams()
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageLink: IPageLink = properties[Property.PageLink] || {};

    if (!siteId || !pageLink.pageId)
        return <button
            type="button"
            className={className}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            {action.name}
        </button>

    const pageUrl = PageLinkHelper.getPageLinkUrl(siteId, pageLink);

    return (
        <Link
            className={clsx(className, "btn btn-secondary btn-sm")}
            to={pageUrl}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Link>
    )
}
